import { render, staticRenderFns } from "./ProjectInfoCard.vue?vue&type=template&id=17335198&scoped=true&"
import script from "./ProjectInfoCard.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfoCard.vue?vue&type=style&index=0&id=17335198&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17335198",
  null
  
)

export default component.exports